import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'


const Line = styled.div`
  width: 40px;
  height: 1px;
  background: white;
  position: absolute;
  transition: transform 0.3s ease, opacity 0.3s ease;
  top: 50%;

  ${media.xs`
    width: 35px;
  `}
`

const Wrapper = styled.div`
  position: relative;
  height: 40px;
  z-index: 7;
  width: 35px;

  ${Line}:first-child {
    transform: ${props => props.active ? 'translateY(1px) rotate(45deg)' : 'translateY(8px)'};
  }
  
  ${Line}:nth-child(2) {
    opacity: ${props => props.active ? 0 : 1};
  }

  ${Line}:last-child {
    transform: ${props => props.active ? 'translateY(1px) rotate(-45deg)' : 'translateY(-8px)'};
  }

  ${media.lg`
    width: 40px;
  `}

  &:hover {
    cursor: pointer;
  }
`

export default class Burger extends Component {
  render() {
    return(
      <Wrapper active={this.props.active}>
        <Line />
        <Line />
        <Line />
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Burger.js